module.exports = __webpack_public_path__ + "static/media/recommendations-image.60638212.png";